<template>
  <header class="form-header">
    <div class="container header__top" :class="{hidden: (!isCrezu && !customLogo) || newDesign}">
      <!-- logo -->
      <svg v-if="!customLogo" class="header__logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 90 25" style="enable-background:new 0 0 90 25;" xml:space="preserve">
          <g>
          <path class="crezuLogo" d="M21,21.3c0,0.1,0,0.2,0,0.4c0,1,0,2,0,3c0,0.3-0.1,0.4-0.3,0.4c-3.7,0-7.5,0-11.2,0c-1.9,0-3.8-0.5-5.4-1.6
          c-1.9-1.2-2.9-3.1-3.5-5.2c-0.4-1.5-0.6-3-0.6-4.5C0,11.7,0,9.6,0.5,7.6C0.8,6.3,1.2,5,1.9,3.8C3.1,2,4.9,0.9,7,0.4
          C8.1,0.2,9.2,0,10.3,0c3.3-0.1,6.6,0,10,0c0.3,0,0.4,0.1,0.4,0.4c0,1,0,2,0,3c0,0.3-0.1,0.4-0.4,0.4c-2.6,0-5.2,0-7.8,0
          c-1,0-2.1,0.1-3.1,0.3C7.3,4.4,6.1,5.8,5.5,7.7c-0.5,1.7-0.6,3.4-0.6,5.1c0,1.4,0.1,2.7,0.4,4.1c0.5,2.3,1.9,3.6,4.1,4
          c0.9,0.2,1.9,0.3,2.9,0.3c2.8,0,5.6,0,8.5,0C20.8,21.3,20.9,21.3,21,21.3z"/>
            <path class="crezuLogo" d="M90,14.2c0,2.5,0,4.9,0,7.4c0,0.4,0,0.7-0.1,1.1c-0.3,1.3-1.1,2-2.5,2.2c-0.5,0.1-1,0.1-1.5,0.1
          c-2.5,0-4.9,0-7.4,0c-0.9,0-1.7-0.2-2.5-0.5c-1.8-0.6-2.8-2-3.2-3.8c-0.2-0.8-0.3-1.5-0.3-2.3c0-4,0-7.9,0-11.9
          c0-0.3,0.1-0.4,0.4-0.4c1.1,0,2.2,0,3.4,0c0.3,0,0.4,0.1,0.4,0.4c0,3.5,0,7,0,10.6c0,0.7,0.1,1.4,0.2,2.1c0.3,1.6,1.1,2.5,2.7,2.6
          c1.7,0.1,3.4,0.1,5.1,0.1c0.7,0,1.1-0.5,1.2-1.2c0-0.2,0-0.4,0-0.7c0-4.5,0-8.9,0-13.4c0-0.5,0-0.5,0.5-0.5c1.1,0,2.2,0,3.3,0
          c0.3,0,0.4,0.1,0.4,0.4C90,9,90,11.6,90,14.2z"/>
            <path class="crezuLogo" d="M70.8,21.8c0,1.1,0,2.1,0,3.1c-0.1,0-0.3,0-0.4,0c-4.4,0-8.8,0-13.2,0c-0.4,0-0.7,0-1.1-0.1
          c-1.1-0.3-1.6-1-1.6-2.3c0-1,0.3-1.8,1-2.5c0.8-0.9,1.7-1.8,2.6-2.6c2.4-2.5,4.9-4.9,7.3-7.3c0.2-0.2,0.5-0.4,0.4-0.7
          c-0.1-0.3-0.5-0.2-0.8-0.2c-3.1,0-6.3,0-9.4,0c-0.6,0-0.5,0-0.5-0.5c0-0.7,0-1.4,0-2.1c0-0.5-0.1-0.5,0.5-0.5c4.2,0,8.4,0,12.6,0
          c0.3,0,0.6,0,0.9,0.1c1.3,0.3,2,1.4,1.8,2.7c-0.1,0.9-0.6,1.7-1.2,2.3c-3.2,3.3-6.4,6.6-9.6,9.9c-0.1,0.1-0.2,0.2-0.3,0.4
          c-0.1,0.2-0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.3,0c3.4,0,6.7,0,10.1,0C70.5,21.8,70.6,21.8,70.8,21.8z"/>
            <path class="crezuLogo" d="M27.8,25c-0.1,0-0.2,0-0.3,0c-1.2,0-2.3,0-3.5,0c-0.3,0-0.3-0.1-0.3-0.3c0-4.1,0-8.2,0-12.3
          c0-0.9,0.2-1.7,0.5-2.5c0.7-2,2.3-3,4.2-3.4c0.8-0.2,1.7-0.2,2.5-0.3c1-0.1,1.9,0,2.9,0c0.2,0,0.3,0.1,0.3,0.3c0,0.9,0,1.7,0,2.6
          c0,0.2-0.1,0.3-0.3,0.3c-0.9,0-1.7,0-2.6,0.1c-1.9,0.2-3,1.4-3.3,3.3c-0.1,0.6-0.1,1.3-0.1,1.9c0,3.3,0,6.6,0,10
          C27.8,24.6,27.8,24.8,27.8,25z"/>
            <path class="crezuLogo" d="M39.9,16.9c3.5,0,7,0,10.6,0c1.6,0,2.5-0.8,2.8-2.4c0.2-1.1,0.1-2.3-0.1-3.4c-0.5-2.5-1.8-4.1-4.3-4.7
          C46.9,6,45,5.9,43,6c-1.1,0.1-2.1,0.2-3.2,0.5c-2.3,0.6-3.8,2-4.3,4.3c-0.2,1.1-0.3,2.3-0.4,3.4c-0.1,2,0,3.9,0.4,5.9
          c0.3,1.4,0.9,2.7,2.1,3.6c1.2,0.8,2.5,1.2,3.9,1.2c3.7,0,7.4,0,11,0c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2,0-0.3c0-0.8,0-1.6,0-2.5
          c0-0.3-0.1-0.4-0.4-0.4c-2.9,0-5.9,0-8.8,0c-0.4,0-0.8,0-1.3-0.1c-1.2-0.2-2.2-0.7-2.6-2c-0.3-0.9-0.3-1.8-0.3-2.8
          C39.6,16.9,39.7,16.9,39.9,16.9z M39.4,13.7c0-1.1,0.1-2.1,0.7-3c0.4-0.7,1.1-1.1,1.8-1.3c1.6-0.4,3.3-0.4,4.9,0
          c1.5,0.5,2.4,1.7,2.3,3.2c0,0.7-0.4,1-1.1,1c-2.8,0-5.6,0-8.3,0C39.6,13.8,39.5,13.7,39.4,13.7z"/>
          </g>
        </svg>
      <img v-else :src="customLogo">
      <!-- logo-ends -->
    </div>
    <div class="container header__bottom">
      <div class="header__progressbar-wrap">
        <div class="header__progressbar-top">
          <p v-if="newDesign">{{ stepLabel }} {{ calculatedStep }}. {{currentTitle}}</p>
          <p v-else>{{currentTitle}}</p>
          <p class="header__progressbar-top__percent">{{progressPercents}}%</p>
        </div>
        <div class="header__progressbar-line">
          <div class="header__progressbar-line__1step"></div>
          <div class="header__progressbar-line__progress" :style="`width: ${progressPercents}%`"></div>
        </div>
        <div class="header__progressbar-bottom" :class="{hidden: newDesign}">
          <div class="header-left">
            <p>{{ stepLabel }} {{ calculatedStep }}</p>
          </div>
          <loan-sum-widget/>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import {mapState} from 'vuex'
import LoanSumWidget from './assetComponents/loanSumWidget'

export default {
  name: 'Header',
  components: {LoanSumWidget},
  data: () => {
    return {
      customLogo: window.customLogo,
      newDesign: window.newDesign
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      loanAmount: state => {
        for (const i in state.history) {
          if (state.history[i].name === 'loan_sum') {
            return state.history[i].value
          }
        }
      },
      progressPercents: state => state.progressPercents,
      stepLabel: state => state.stepLabel,
      currentTitle: state => {
        const field = state.history[state.currentStep]
        if (field.field && field.field.category) return field.field.category
        let i = 0
        let categoryIndex = 3
        for (let c in state.config.params.dividers_data) {
          if (state.config.params.dividers_data[c].includes(field.name)) {
            categoryIndex = i
            break
          }
          i += 1
        }
        return state.config.params.dividers[categoryIndex]
      },
      calculatedStep: state => {
        let step = 1
        let i = 0
        while (i < state.currentStep) {
          if (!state.history[i].skip && state.history[i].name !== 'surname' && state.history[i].name !== 'surname_second') step += 1
          i += 1
        }
        return step
      }
    }),
    isCrezu: () => {
      const domain = window.location.hostname
      return domain.indexOf('crezu') > -1 || domain === 'localhost'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Header.vue